<div class="dashboard-skeleton-container">
  <!-- Page Title -->
  <div class="page-title">
    <ngx-skeleton-loader
      [theme]="{
        'border-radius': '0.25rem',
        height: '1.5rem',
        width: '6rem',
        'background-color': placeholderStyles.backgroundColor,
      }"
    ></ngx-skeleton-loader>
  </div>

  <!-- Filter Row -->
  <div class="filter-row">
    <!-- From Date -->
    <div class="filter-field">
      <ngx-skeleton-loader
        [theme]="inputPlaceholderStyle"
      ></ngx-skeleton-loader>
    </div>

    <!-- To Date -->
    <div class="filter-field">
      <ngx-skeleton-loader
        [theme]="inputPlaceholderStyle"
      ></ngx-skeleton-loader>
    </div>

    <!-- Seller Dropdown -->
    <div class="filter-field">
      <ngx-skeleton-loader
        [theme]="inputPlaceholderStyle"
      ></ngx-skeleton-loader>
    </div>

    <!-- Filter Button -->
    <div class="filter-button">
      <ngx-skeleton-loader
        [theme]="{
          'border-radius': '0.45rem',
          height: '2.5rem',
          width: '100%',
          'background-color': placeholderStyles.backgroundColor,
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>

  <!-- Cards Container -->
  <div class="cards-container">
    <!-- Left Card - Statistics Table -->
    <div class="card statistics-card">
      <!-- Card Title -->
      <div class="card-title">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '0.25rem',
            height: '1.25rem',
            width: '12rem',
            'background-color': placeholderStyles.backgroundColor,
            'margin-bottom': '1rem',
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Filter Chips -->
      <div class="chips-row">
        <ngx-skeleton-loader
          *ngFor="let chip of [1, 2, 3, 4]"
          [theme]="{
            'border-radius': '1rem',
            height: '2rem',
            width: '4.5rem',
            'background-color': placeholderStyles.backgroundColor,
            'margin-left': '0.5rem',
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Table Header -->
      <div class="table-header">
        <ngx-skeleton-loader
          *ngFor="let header of [1, 2, 3, 4]"
          [theme]="{
            'border-radius': '0.25rem',
            height: '1rem',
            width: '4rem',
            'background-color': placeholderStyles.backgroundColor,
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Table Rows -->
      <div class="table-row" *ngFor="let row of [1, 2, 3]">
        <ngx-skeleton-loader
          *ngFor="let cell of [1, 2, 3, 4]"
          [theme]="{
            'border-radius': '0.25rem',
            height: '1rem',
            width: '5rem',
            'background-color': placeholderStyles.backgroundColor,
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <!-- Right Card - Chart -->
    <div class="card chart-card">
      <!-- Card Title -->
      <div class="card-title">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '0.25rem',
            height: '1.25rem',
            width: '14rem',
            'background-color': placeholderStyles.backgroundColor,
            'margin-bottom': '1rem',
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Filter Chips Row 1 -->
      <div class="chips-row">
        <ngx-skeleton-loader
          *ngFor="let chip of [1, 2, 3, 4]"
          [theme]="{
            'border-radius': '1rem',
            height: '2rem',
            width: '4.5rem',
            'background-color': placeholderStyles.backgroundColor,
            'margin-left': '0.5rem',
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Filter Chips Row 2 -->
      <div class="chips-row">
        <ngx-skeleton-loader
          *ngFor="let chip of [1, 2, 3]"
          [theme]="{
            'border-radius': '1rem',
            height: '2rem',
            width: '3.5rem',
            'background-color': placeholderStyles.backgroundColor,
            'margin-left': '0.5rem',
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Chart Legend -->
      <div class="chart-legend">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '0.25rem',
            height: '1rem',
            width: '5rem',
            'background-color': placeholderStyles.backgroundColor,
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Pie Chart Placeholder -->
      <div class="chart-container">
        <ngx-skeleton-loader
          appearance="circle"
          [theme]="{
            height: '12rem',
            width: '12rem',
            'background-color': placeholderStyles.backgroundColor,
          }"
        ></ngx-skeleton-loader>
      </div>

      <!-- Chart Value -->
      <div class="chart-value">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '0.25rem',
            height: '1rem',
            width: '8rem',
            'background-color': placeholderStyles.backgroundColor,
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
